module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("promo_social_buttons", [["a",{"class":"soc-button facebook","data-request-url":"","data-app-name":"facebook"},[["textNode",{"text":"Facebook"}]],[["facebookUrl","data-request-url",true]]],["textNode",{"text":" "}],["a",{"class":"soc-button blue-btn twitter","data-request-url":"","data-app-name":"twitter"},[["textNode",{"text":"Twitter"}]],[["twitterUrl","data-request-url",true]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!../promo/templates/sitepage/promo/socialButtons.tpl
// module id = 552
// module chunks = 2